export default __webpack_public_path__ + "static/media/toRight.1b6e088e.png";